import { echarts, COLOR_LIST } from "../config"

export function defaultSeriesSettings () {
    return {
        type: "line",
        seriesLayoutBy: "column", // row
        symbolSize: 8,
        // markLine: {
        //     data: [{
        //         type: "average",
        //         name: "平均值"
        //     }]
        // },
        areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(58,77,233,0.8)"
            }, {
                offset: 1,
                color: "rgba(58,77,233,0.3)"
            }])
        }
    }
}

export default function defaultSettings () {
    return {
        color: COLOR_LIST,
        title: {
            text: "标题",
            left: "center",
            top: "0",
            textStyle: {
                fontSize: 18,
                color: "#333",
                fontWeight: 600
            }
        },
        tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0,0,0, .4)",
            textStyle: {
                color: "#fff"
            }
        },
        legend: {
            orient: "horizontal", /* vertical */
            left: "center",
            top: 20,
            icon: "pin",
            padding: 10
            // icon: 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none',
        },
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
        },
        toolbox: {
            // feature: {
            //   saveAsImage: {}
            // }
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            gridIndex: 0
        },
        yAxis: {
            gridIndex: 0,
            type: "value"
        },
        series: [
            // 这几个系列会在第一个直角坐标系中，每个系列对应到 dataset 的每一行。
            defaultSeriesSettings()
        ]
    }
}
